import type {Variant} from '../ToolBoxButton/types';

import AppleIcon from '../../assets/icons-colored/apple-red.png';
import TrackersIcon from '../../assets/icons-colored/trackers-blue.png';
import LogoSvg from '../ToolBoxButton/assets/logo.svg';

export const getIcon = (variant: Variant) => {
  switch (variant) {
    case 'food_diary':
      return AppleIcon;
    case 'trackers':
      return TrackersIcon;
    default:
      return LogoSvg;
  }
};
